"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var state_1 = __importDefault(require("./state"));
var navigation_button_1 = __importStar(require("../views/navigation-button"));
var pixi_textinput_v5_1 = require("pixi-textinput-v5");
var color_1 = require("../utilities/color");
var game_area_1 = require("../utilities/game-area");
var i18next_1 = __importDefault(require("i18next"));
var NameState = /** @class */ (function (_super) {
    __extends(NameState, _super);
    function NameState(app, client, backdropContainer, dragonContainer) {
        var _this = _super.call(this) || this;
        _this._app = app;
        _this._client = client;
        _this._backdropContainer = backdropContainer;
        _this._dragonContainer = dragonContainer;
        return _this;
    }
    Object.defineProperty(NameState.prototype, "backButton", {
        get: function () {
            var _this = this;
            if (!this._backButton) {
                this._backButton = new navigation_button_1.default(this._app.loader.resources.ui.textures, navigation_button_1.NAVIGATION_BUTTON_TYPE.BACK, function () {
                    _this.stateMachine.pop();
                });
                this._backButton.position.set(game_area_1.GAME_SAFE_AREA.left + 12, game_area_1.GAME_SAFE_AREA.top + 12);
            }
            return this._backButton;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NameState.prototype, "textInput", {
        get: function () {
            if (!this._textInput) {
                this._textInput = new pixi_textinput_v5_1.TextInput({
                    input: {
                        fontFamily: "Arial",
                        fontSize: "18pt",
                        padding: "10px",
                        width: "200px",
                        height: "56px",
                        boxSizing: "border-box",
                        color: "#26272E",
                    }, box: {
                        fill: color_1.COLOR.WHITE, rounded: 18, stroke: { color: color_1.COLOR.OFF_WHITE, width: 2 }
                    }
                });
                this._textInput.maxLength = 12;
                this._textInput.placeholder = i18next_1.default.t("name_placeholder");
                this._textInput.restrict = /^[^<>\/\\\[\]{}*+=@#~%^()]*$/;
                this._textInput.position.set((game_area_1.GAME_WIDTH - this._textInput.width) * 0.5, game_area_1.GAME_SAFE_AREA.top + 12);
            }
            return this._textInput;
        },
        enumerable: false,
        configurable: true
    });
    NameState.prototype.didEnterFrom = function (previousState) {
        _super.prototype.didEnterFrom.call(this, previousState);
        this._app.stage.addChild(this._backdropContainer);
        this._app.stage.addChild(this.backButton);
        this._app.stage.addChild(this.textInput);
        this._dragonContainer.setIdleAnimation();
        this._backdropContainer.dragonSlot.addChild(this._dragonContainer);
        this.beginEditing();
        this._client.sendEvent("name_entered");
    };
    NameState.prototype.willExitTo = function (nextState) {
        _super.prototype.willExitTo.call(this, nextState);
        this._app.stage.removeChild(this._backdropContainer);
        this._app.stage.removeChild(this.backButton);
        this._app.stage.removeChild(this.textInput);
        this._backdropContainer.dragonSlot.removeChild(this._dragonContainer);
        this.endEditing();
    };
    NameState.prototype.beginEditing = function () {
        var _a;
        this.textInput.substituteText = false;
        this.textInput.text = (_a = this._client.dragon.status.name) !== null && _a !== void 0 ? _a : "";
    };
    NameState.prototype.endEditing = function () {
        var text = this.textInput.text;
        if (text != this._client.dragon.status.name) {
            this._client.dragon.status.name = text;
            this._client.synchronize();
            this._client.sendEvent("name_changed", {
                name: text
            });
        }
        this.textInput.substituteText = true;
    };
    return NameState;
}(state_1.default));
exports.default = NameState;
